"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_URL = 'https://api.cimpress.io/auth/access-management/v1';
function getBaseUrl() {
    return exports.BASE_URL;
}
exports.getBaseUrl = getBaseUrl;
function setBaseUrl(baseUrl) {
    exports.BASE_URL = baseUrl;
}
exports.setBaseUrl = setBaseUrl;
//# sourceMappingURL=base-url.js.map